import { z } from 'zod';
import {
  EntityRole,
  IEntityRoleAssignmentInput,
} from '../../utils/apollo/graphqlSchema';

const entityPermissionsWidgetUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  picture: z.string(),
  role: z.nativeEnum(EntityRole),
});

export const entityPermissionsWidgetSchema = z.object({
  defaultPublicRole: z.nativeEnum(EntityRole),
  users: z.array(entityPermissionsWidgetUserSchema),
});

export type IEntityPermissionsWidgetUser = z.infer<
  typeof entityPermissionsWidgetUserSchema
>;
export type IEntityPermissionsWidgetState = z.infer<
  typeof entityPermissionsWidgetSchema
>;

export const prepareEntityRoleAssignmentInput = (
  formDataUsers: IEntityPermissionsWidgetUser[],
): IEntityRoleAssignmentInput[] => {
  return formDataUsers.reduce<IEntityRoleAssignmentInput[]>(
    (acc, { id, role }) => {
      const roleAssignmentIndex = acc.findIndex(
        (roleAssignment) => roleAssignment.role === role,
      );

      if (roleAssignmentIndex === -1) {
        acc.push({ userIds: [id], groupIds: [], role });
      } else {
        acc[roleAssignmentIndex].userIds.push(id);
      }

      return acc;
    },
    [],
  );
};

export const publicRoleOptions = [
  EntityRole.Manager,
  EntityRole.Editor,
  EntityRole.Viewer,
];

export const userRoleOptions = [EntityRole.Manager, EntityRole.Editor];
